import React, { useEffect, useState, useContext } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Button,
  Grid,
  Paper,
  Typography,
  Link,
  Divider,
  TextField,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import {
  ThemeProvider,
  createMuiTheme,
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import * as consts from "../consts";
import { State } from "../store/state";
import { dismissAlert, saveHearMessage, getOrder } from "../store/actions";
import Alert from "./presentational/alert";

const App = (props) => {
  const generateClassName = createGenerateClassName({
    seed: "tbreceipt",
  });

  const theme = createMuiTheme(props.theme);
  const useStyles = makeStyles((theme) => ({
    main: { paddingTop: theme.spacing(2) },
    area: {
      [theme.breakpoints.down("xs")]: {
        margin: "auto",
      },
    },
    paper: {
      padding: theme.spacing(2),
      width: "100%",
    },
    share: {
      "& div": {
        margin: "auto",
      },
      "& img": {
        width: "14vw",
        [theme.breakpoints.down("sm")]: {
          maxWidth: "150px",
        },
        [theme.breakpoints.up("sm")]: {
          maxWidth: "100px",
        },
      },
    },
    link: {
      display: "inline-block",
    },
    total: {
      "& img": {
        width: "100%",
        maxWidth: "100px",
      },
    },
    cardImage: {
      backgroundRepeat: "no-repeat",
      backgroundColor: "#ffffff",
      borderRadius: "14px",
      border: "1px solid #d8d8d8",
      backgroundSize: "cover",
      overflow: "hidden",
      maxWidth: "100px",
    },
    overlay: {
      width: "100%",
      display: "block",
    },
    submitButton: {
      height: "56px",
      "&:hover": { color: "#272643" },
    },
    orderButton: {
      color: "#ffffff",
      margin: "10px 10px 10px 0px",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    downloadButton: {
      margin: "10px 10px 10px 0px",
      "&:hover": { color: "#272643" },
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#ffffff",
    },
    typeTitle: {
      marginTop: "0px !important",
    },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);
  const { isLoading, isAuthenticated, user, getAccessTokenSilently } =
    useAuth0();

  const [hear, setHear] = useState("*");
  const [hearMessage, setHearMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const getQueryParams = (params, url) => {
    let href = url;
    let reg = new RegExp("[?&]" + params + "=([^&#]*)", "i");
    let queryString = reg.exec(href);
    return queryString ? decodeURI(queryString[1]) : null;
  };

  useEffect(() => {
    setBusy(true);
    let orderID = getQueryParams("orderid", location.href);
    getOrder(orderID, getAccessTokenSilently, dispatch).then(
      (getOrderResponse) => {
        //trackGoogle(getOrderResponse);
        trackFB(getOrderResponse);
        setBusy(false);
      }
    );
  }, []);

  let trackFB = (getOrderResponse) => {
    if (typeof window !== "undefined") {
      if (window.fbq != null) {
        let cardTotal = 0;
        let productionTotal = 0;
        let shippingTotal = 0;
        let productionFee = 0;

        if (getOrderResponse) {
          getOrderResponse.cartItems.map((cartItem, cartItemIndex) => {
            if (
              cartItem.cardType == consts.CARD_TYPE_PLASTIC &&
              cartItem.mailOption == consts.PLASTIC_TYPE_ME
            ) {
              productionFee + 3.29;
              cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
                cardTotal += cartItem.cardValue;
                if (cardDetail.cardFee) {
                  productionTotal += cardDetail.cardFee.productionFee;
                  if (cartItemIndex == 0 && cardDetailIndex == 0) {
                    shippingTotal += cardDetail.cardFee.shippingHandling;
                  }
                }
              });
            }
            if (
              cartItem.cardType == consts.CARD_TYPE_PLASTIC &&
              cartItem.mailOption == consts.PLASTIC_TYPE_THEM
            ) {
              productionFee + 3.29;
              cartItem.cardDetails.map((cardDetail) => {
                cardTotal += cartItem.cardValue;
                if (cardDetail.cardFee) {
                  productionTotal += cardDetail.cardFee.productionFee;
                  shippingTotal += cardDetail.cardFee.shippingHandling;
                }
              });
            }
            if (
              cartItem.cardType == consts.CARD_TYPE_EMAIL &&
              cartItem.emailOption == consts.EMAIL_TYPE_NOW
            ) {
              cartItem.cardDetails.map((cardDetail) => {
                cardTotal += cartItem.cardValue;
                if (cardDetail.cardFee) {
                  productionTotal += cardDetail.cardFee.productionFee;
                }
              });
            }
            if (
              cartItem.cardType == consts.CARD_TYPE_EMAIL &&
              cartItem.emailOption == consts.EMAIL_TYPE_LATER
            ) {
              cartItem.cardDetails.map((cardDetail) => {
                cardTotal += cartItem.cardValue;
                if (cardDetail.cardFee) {
                  productionTotal += cardDetail.cardFee.productionFee;
                }
              });
            }
            if (cartItem.cardType == consts.CARD_TYPE_PRINTER) {
              cartItem.cardDetails.map((cardDetail) => {
                cardTotal += cartItem.cardValue;
                if (cardDetail.cardFee) {
                  productionTotal += cardDetail.cardFee.productionFee;
                }
              });
            }
          });
        }

        window.fbq("track", "Purchase", {
          value:
            cardTotal +
            productionTotal +
            shippingTotal +
            getOrderResponse.donationAmount +
            productionFee,
          currency: "USD",
        });
      }
    }
  };

  useEffect(() => {
    if (hearMessage) {
      saveHearMessage(hear, getAccessTokenSilently, dispatch);
    }
  }, [hearMessage]);

  const convertToMoney = (value) => {
    let decPlaces = 2;
    let decSep = ".";
    let thouSep = ",";
    var sign = value < 0 ? "-$" : "$";
    var i = String(
      parseInt((value = Math.abs(Number(value) || 0).toFixed(decPlaces)))
    );
    var j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(value - i)
            .toFixed(decPlaces)
            .slice(2)
        : "")
    );
  };

  let plasticMeItems =
    state.order && state.order.cartItems
      ? state.order.cartItems.filter((item) => {
          return (
            item.cardType == consts.CARD_TYPE_PLASTIC &&
            item.mailOption == consts.PLASTIC_TYPE_ME
          );
        })
      : [];
  let plasticNoCarrierCartItems =
    state.order && state.order.cartItems
      ? state.order.cartItems.filter((item) => {
          return (
            item.cardType == consts.CARD_TYPE_PLASTIC &&
            item.mailOption == consts.PLASTIC_TYPE_NO_CARRIER
          );
        })
      : [];
  let plasticThemItems =
    state.order && state.order.cartItems
      ? state.order.cartItems.filter((item) => {
          return (
            item.cardType == consts.CARD_TYPE_PLASTIC &&
            item.mailOption == consts.PLASTIC_TYPE_THEM
          );
        })
      : [];
  let emailNowItems =
    state.order && state.order.cartItems
      ? state.order.cartItems.filter((item) => {
          return (
            item.cardType == consts.CARD_TYPE_EMAIL &&
            item.emailOption == consts.EMAIL_TYPE_NOW
          );
        })
      : [];
  let emailLaterItems =
    state.order && state.order.cartItems
      ? state.order.cartItems.filter((item) => {
          return (
            item.cardType == consts.CARD_TYPE_EMAIL &&
            item.emailOption == consts.EMAIL_TYPE_LATER
          );
        })
      : [];
  let printerItems =
    state.order && state.order.cartItems
      ? state.order.cartItems.filter((item) => {
          return item.cardType == consts.CARD_TYPE_PRINTER;
        })
      : [];

  const renderPlasticMeCards = () => {
    if (plasticMeItems && plasticMeItems.length > 0) {
      return (
        <Grid item container xs={12} spacing={2}>
          {plasticMeItems.map((cartItem) => {
            return (
              <React.Fragment key={cartItem.cartItemID}>
                <Grid item xs={4}>
                  <div
                    className={classes.cardImage}
                    style={{
                      backgroundImage: "url('" + cartItem.cardImage + "')",
                    }}
                  >
                    <img
                      className={classes.overlay}
                      src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                    />
                  </div>
                </Grid>
                <Grid item xs={8} className={classes.subtotal}>
                  <Typography variant="caption" component="div">
                    <span>{cartItem.cardDetails.length}</span>
                    <span>&nbsp;x&nbsp;</span>
                    <span>
                      <b>{convertToMoney(cartItem.cardValue)}</b>
                    </span>
                  </Typography>
                  <Typography
                    variant="caption"
                    component="div"
                    className={classes.typeTitle}
                  >
                    Mail to me
                  </Typography>
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      );
    } else {
      return null;
    }
  };
  const renderNoCarrierCards = () => {
    if (plasticNoCarrierCartItems && plasticNoCarrierCartItems.length > 0) {
      return (
        <Grid item container xs={12} spacing={2}>
          {plasticNoCarrierCartItems.map((cartItem) => {
            return (
              <React.Fragment key={cartItem.cartItemID}>
                <Grid item xs={4}>
                  <div
                    className={classes.cardImage}
                    style={{
                      backgroundImage: "url('" + cartItem.cardImage + "')",
                    }}
                  >
                    <img
                      className={classes.overlay}
                      src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                    />
                  </div>
                </Grid>
                <Grid item xs={8} className={classes.subtotal}>
                  <Typography variant="caption" component="div">
                    <span>{cartItem.cardDetails.length}</span>
                    <span>&nbsp;x&nbsp;</span>
                    <span>
                      <b>{convertToMoney(cartItem.cardValue)}</b>
                    </span>
                  </Typography>
                  <Typography
                    variant="caption"
                    component="div"
                    className={classes.typeTitle}
                  >
                    Plastic Card Only - No Notecard
                  </Typography>
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      );
    } else {
      return null;
    }
  };
  const renderPlasticThemCards = () => {
    if (plasticThemItems && plasticThemItems.length > 0) {
      return (
        <Grid item container xs={12} spacing={2}>
          {plasticThemItems.map((cartItem) => {
            return (
              <React.Fragment key={cartItem.cartItemID}>
                <Grid item xs={4}>
                  <div
                    className={classes.cardImage}
                    style={{
                      backgroundImage: "url('" + cartItem.cardImage + "')",
                    }}
                  >
                    <img
                      className={classes.overlay}
                      src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                    />
                  </div>
                </Grid>
                <Grid item xs={8} className={classes.subtotal}>
                  <Typography variant="caption" component="div">
                    <span>{cartItem.cardDetails.length}</span>
                    <span>&nbsp;x&nbsp;</span>
                    <span>
                      <b>{convertToMoney(cartItem.cardValue)}</b>
                    </span>
                  </Typography>
                  <Typography
                    variant="caption"
                    component="div"
                    className={classes.typeTitle}
                  >
                    Mail to them
                  </Typography>
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      );
    } else {
      return null;
    }
  };
  const renderEmailNowCards = () => {
    if (emailNowItems && emailNowItems.length > 0) {
      return (
        <Grid item container xs={12} spacing={2}>
          {emailNowItems.map((cartItem) => {
            return (
              <React.Fragment key={cartItem.cartItemID}>
                <Grid item xs={4}>
                  <div
                    className={classes.cardImage}
                    style={{
                      backgroundImage: "url('" + cartItem.cardImage + "')",
                    }}
                  >
                    <img
                      className={classes.overlay}
                      src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                    />
                  </div>
                </Grid>
                <Grid item xs={8} className={classes.subtotal}>
                  <Typography variant="caption" component="div">
                    <span>{cartItem.cardDetails.length}</span>
                    <span>&nbsp;x&nbsp;</span>
                    <span>
                      <b>{convertToMoney(cartItem.cardValue)}</b>
                    </span>
                  </Typography>
                  <Typography
                    variant="caption"
                    component="div"
                    className={classes.typeTitle}
                  >
                    Digital
                  </Typography>
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      );
    } else {
      return null;
    }
  };
  const renderEmailLaterCards = () => {
    if (emailLaterItems && emailLaterItems.length > 0) {
      return (
        <Grid item container xs={12} spacing={2}>
          {emailLaterItems.map((cartItem) => {
            return (
              <React.Fragment key={cartItem.cartItemID}>
                <Grid item xs={4}>
                  <div
                    className={classes.cardImage}
                    style={{
                      backgroundImage: "url('" + cartItem.cardImage + "')",
                    }}
                  >
                    <img
                      className={classes.overlay}
                      src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                    />
                  </div>
                </Grid>
                <Grid item xs={8} className={classes.subtotal}>
                  <Typography variant="caption" component="div">
                    <span>{cartItem.cardDetails.length}</span>
                    <span>&nbsp;x&nbsp;</span>
                    <span>
                      <b>{convertToMoney(cartItem.cardValue)}</b>
                    </span>
                  </Typography>
                  <Typography
                    variant="caption"
                    component="div"
                    className={classes.typeTitle}
                  >
                    Digital
                  </Typography>
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      );
    } else {
      return null;
    }
  };
  const renderPrinterCards = () => {
    if (printerItems && printerItems.length > 0) {
      return (
        <Grid item container xs={12} spacing={2}>
          {printerItems.map((cartItem) => {
            return (
              <React.Fragment key={cartItem.cartItemID}>
                <Grid item xs={4}>
                  <div
                    className={classes.cardImage}
                    style={{
                      backgroundImage: "url('" + cartItem.cardImage + "')",
                    }}
                  >
                    <img
                      className={classes.overlay}
                      src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                    />
                  </div>
                </Grid>
                <Grid item xs={8} className={classes.subtotal}>
                  <Typography variant="caption" component="div">
                    <span>{cartItem.cardDetails.length}</span>
                    <span>&nbsp;x&nbsp;</span>
                    <span>
                      <b>{convertToMoney(cartItem.cardValue)}</b>
                    </span>
                  </Typography>
                  <Typography
                    variant="caption"
                    component="div"
                    className={classes.typeTitle}
                  >
                    Printer
                  </Typography>
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderTotal = () => {
    let cardTotal = 0;
    let productionTotal = 0;
    let shippingTotal = 0;
    let creditCardFee = 0;

    [...plasticMeItems, ...plasticNoCarrierCartItems].map(
      (cartItem, cartItemIndex) => {
        cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
          cardTotal += cartItem.cardValue;
          if (cardDetail.cardFee) {
            productionTotal += cardDetail.cardFee.productionFee;
            if (cartItemIndex == 0 && cardDetailIndex == 0) {
              shippingTotal += cardDetail.cardFee.shippingHandling;
            }
          }
        });
      }
    );

    plasticThemItems.map((cartItem) => {
      cartItem.cardDetails.map((cardDetail) => {
        cardTotal += cartItem.cardValue;
        if (cardDetail.cardFee) {
          productionTotal += cardDetail.cardFee.productionFee;
          shippingTotal += cardDetail.cardFee.shippingHandling;
        }
      });
    });

    emailNowItems.map((cartItem) => {
      cartItem.cardDetails.map((cardDetail) => {
        cardTotal += cartItem.cardValue;
        if (cardDetail.cardFee) {
          productionTotal += cardDetail.cardFee.productionFee;
        }
      });
    });

    emailLaterItems.map((cartItem) => {
      cartItem.cardDetails.map((cardDetail) => {
        cardTotal += cartItem.cardValue;
        if (cardDetail.cardFee) {
          productionTotal += cardDetail.cardFee.productionFee;
        }
      });
    });

    printerItems.map((cartItem) => {
      cartItem.cardDetails.map((cardDetail) => {
        cardTotal += cartItem.cardValue;
        if (cardDetail.cardFee) {
          productionTotal += cardDetail.cardFee.productionFee;
        }
      });
    });
    return (
      <Grid item container xs={12} className={classes.total}>
        <Paper className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                color="primary"
                className={classes.header}
              >
                Order Summary
              </Typography>
            </Grid>
            {renderPlasticMeCards()}
            {renderNoCarrierCards()}
            {renderPlasticThemCards()}
            {renderEmailNowCards()}
            {renderEmailLaterCards()}
            {renderPrinterCards()}
            <Grid item xs={12}>
              <Divider variant="middle" />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">Gift Card Total</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(cardTotal)}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">Production Costs</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(productionTotal)}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">Shipping</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(shippingTotal)}
              </Typography>
            </Grid>
            {state.order.creditCardFee && state.order.creditCardFee > 0 ? (
              <React.Fragment>
                <Grid item xs={8}>
                  <Typography variant="body1">
                    Credit Card Processor 3%
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body1" align="right">
                    {convertToMoney(state.order.creditCardFee)}
                  </Typography>
                </Grid>
              </React.Fragment>
            ) : null}
            <Grid item xs={8}>
              <Typography variant="body1">Support TisBest</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(state.order.donationAmount)}
              </Typography>
            </Grid>
            {state.order &&
              state.order.orderAdjustments &&
              state.order.orderAdjustments.map((orderAdjustment) => {
                return (
                  <React.Fragment>
                    <Grid item xs={8}>
                      <Typography variant="body1">
                        {orderAdjustment.description}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body1" align="right">
                        {convertToMoney(orderAdjustment.amount)}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                );
              })}
            <Grid item xs={8}>
              <Typography variant="body1">Total</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(state.order.total)}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  };

  const renderMessage = () => {
    return (
      <Grid item container xs={12} className={classes.message}>
        <Paper className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                color="primary"
                className={classes.header}
              >
                Thank you! Your order #{state.order.orderID} is on its way.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.body}>
                Within a few minutes, you will receive an email receipt
                from&nbsp;
                <Link href="mailto:orders@tisbest.org">orders@tisbest.org</Link>
                &nbsp;that contains your Order Details link, also available
                below.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.body}>
                View Order Details for delivery information, to access and track
                your Charity Gift Cards, and for your payment and donation
                receipts. Download All Cards to access a printable/PDF version
                of all of your cards.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                className={classes.orderButton}
                variant="contained"
                color="secondary"
                onClick={() => {
                  window.open(`/order/?orderid=${state.order.transactionID}`);
                }}
              >
                View Order Details
              </Button>
              <Button
                className={classes.downloadButton}
                variant="outlined"
                color="secondary"
                onClick={() => {
                  window.open(
                    `${consts.PRINT_URL}?orderId=${state.order.transactionID}`
                  );
                }}
              >
                Download All Cards
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Divider variant="middle" />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                color="primary"
                className={classes.header}
              >
                How did you hear about us?
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                className={classes.input}
                fullWidth={true}
                select={true}
                variant="outlined"
                value={hear}
                onChange={(event) => {
                  setHear(event.target.value);
                }}
              >
                <MenuItem value="*" disabled>
                  <em>Please choose</em>
                </MenuItem>
                <MenuItem value="TBCGC">
                  Received a TisBest Charity Gift Card
                </MenuItem>
                <MenuItem value="WOM">Word of mouth</MenuItem>
                <MenuItem value="Social">Social media</MenuItem>
                <MenuItem value="Article">Online article or review</MenuItem>
                <MenuItem value="RG">RedefineGifting</MenuItem>
                <MenuItem value="Ellen">The Ellen Degeneres Show</MenuItem>
                <MenuItem value="Inspirato">Inspirato</MenuItem>
                <MenuItem value="Search">
                  Searching for a meaningful gift
                </MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Button
                className={classes.submitButton}
                fullWidth={true}
                variant="outlined"
                disabled={hear == "*"}
                color="secondary"
                onClick={() => {
                  let message = "";
                  switch (hear) {
                    case "TBCGC":
                      message =
                        "Thank you for letting us know (Received a TisBest Charity Gift Card) was where you heard about us.";
                      break;
                    case "PBS":
                      message =
                        "Thank you for letting us know (PBS/Frontline) was where you heard about us.";
                      break;
                    case "Article":
                      message =
                        "Thank you for letting us know (An internet article or list) was where you heard about us.";
                      break;
                    case "Video":
                      message =
                        "Thank you for letting us know (Online video ad) was where you heard about us.";
                      break;
                    case "NPR":
                      message =
                        "Thank you for letting us know (NPR) was where you heard about us.";
                      break;
                    case "FinMag":
                      message =
                        "Thank you for letting us know (Financial Magazine) was where you heard about us.";
                      break;
                    case "FinEmail":
                      message =
                        "Thank you for letting us know (Financial email) was where you heard about us.";
                      break;
                    case "Chinook":
                      message =
                        "Thank you for letting us know (ChinookBook) was where you heard about us.";
                      break;
                    case "Podcast":
                      message =
                        "Thank you for letting us know (Podcast) was where you heard about us.";
                      break;
                    case "MJ":
                      message =
                        "Thank you for letting us know (Mother Jones) was where you heard about us.";
                      break;
                    case "PerfectMom":
                      message =
                        "Thank you for letting us know (ThePerfectMom) was where you heard about us.";
                      break;
                    case "Facebook":
                      message =
                        "Thank you for letting us know (Facebook) was where you heard about us.";
                      break;
                    case "Instagram":
                      message =
                        "Thank you for letting us know (Instagram) was where you heard about us.";
                      break;
                    case "Twitter":
                      message =
                        "Thank you for letting us know (Twitter) was where you heard about us.";
                      break;
                    case "LinkedIn":
                      message =
                        "Thank you for letting us know (LinkedIn) was where you heard about us.";
                      break;
                    case "Blog":
                      message =
                        "Thank you for letting us know (Blog post) was where you heard about us.";
                      break;
                    case "WOM":
                      message =
                        "Thank you for letting us know (Word of mouth) was where you heard about us.";
                      break;
                    case "Search":
                      message =
                        "Thank you for letting us know (Searching for a meaningful gift) was where you heard about us.";
                      break;
                    case "Other":
                      message =
                        "Thank you for letting us know (Other) was where you heard about us.";
                      break;
                  }
                  setHearMessage(message);
                }}
              >
                Submit
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption">{hearMessage}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider variant="middle" />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                color="primary"
                className={classes.header}
              >
                Spread the gift of good!
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.body}>
                Your contributions will change the world. Share the good work
                we're doing together, and let others know about a better way to
                give!
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={12} className={classes.share}>
              <div>
                <a
                  href="http://www.facebook.com/TisBest/"
                  target="_blank"
                  className={classes.link}
                >
                  <img src={`${consts.BLOB_URL}images/facebook.png`} />
                </a>
                <a
                  href="http://www.twitter.com/TisBest/"
                  target="_blank"
                  className={classes.link}
                >
                  <img src={`${consts.BLOB_URL}images/twitter.png`} />
                </a>
                <a
                  href="https://www.instagram.com/tisbestcards/"
                  target="_blank"
                  className={classes.link}
                >
                  <img src={`${consts.BLOB_URL}images/instagram.png`} />
                </a>
                <a
                  href="http://www.linkedin.com/company/298478"
                  target="_blank"
                  className={classes.link}
                >
                  <img src={`${consts.BLOB_URL}images/linkedin.png`} />
                </a>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  };

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline className={classes.main}>
          <Backdrop className={classes.backdrop} open={busy}>
            <CircularProgress color="inherit" />
          </Backdrop>
          {state.alerts.length > 0 && (
            <Alert
              alert={state.alerts[0]}
              onDismiss={() => {
                dismissAlert(dispatch);
              }}
            />
          )}
          <Grid container spacing={2}>
            <Grid
              item
              container
              spacing={2}
              xs={12}
              sm={8}
              className={classes.area}
            >
              {renderMessage()}
            </Grid>
            <Grid
              item
              container
              spacing={2}
              xs={12}
              sm={4}
              className={classes.area}
            >
              {renderTotal()}
            </Grid>
          </Grid>
        </ScopedCssBaseline>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default App;
